"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconSkipForward15 = Experimental__IconSkipForward15;
exports.IconSkipForward15 = IconSkipForward15;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconSkipForward15/index.tsx)
 */
function IconSkipForward15(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M13.536 4.488h-1.473a.75.75 0 1 0 0 1.5H16V2.051a.75.75 0 0 0-1.5 0v1.27A8.25 8.25 0 1 0 3.962 15.876a.75.75 0 0 0 .826-1.252 6.75 6.75 0 1 1 8.747-10.136Z\'/><path d=\'M11.81 15.681c.433.198.921.297 1.464.297.55 0 1.03-.124 1.44-.374.419-.25.738-.586.958-1.012.22-.432.33-.913.33-1.44 0-.507-.103-.95-.308-1.332a2.156 2.156 0 0 0-.858-.88 2.416 2.416 0 0 0-1.221-.308c-.294 0-.565.052-.814.154a1.77 1.77 0 0 0-.616.407c-.1.105-.18.211-.237.319l.211-2.134h3.436V7.981h-4.642l-.44 4.61h1.474a1.24 1.24 0 0 1 .462-.518c.212-.14.462-.209.748-.209.256 0 .48.059.67.176.199.118.349.283.452.495.11.206.165.444.165.715 0 .272-.055.514-.165.726a1.135 1.135 0 0 1-.451.495 1.25 1.25 0 0 1-.671.176c-.25 0-.47-.051-.66-.154a1.155 1.155 0 0 1-.451-.429 1.295 1.295 0 0 1-.176-.638h-1.518c.014.536.146.998.396 1.386a2.46 2.46 0 0 0 1.023.87Zm-5.858-5.346V9.28c.697-.051 1.199-.18 1.507-.385.315-.205.51-.51.583-.913h1.32v7.81H7.855v-5.456H5.952Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M18.714 6H16.75a1 1 0 1 0 0 2H22V2.75a1 1 0 1 0-2 0v1.694A10.97 10.97 0 0 0 12.006 1c-6.075 0-11 4.925-11 11a10.99 10.99 0 0 0 4.943 9.183 1 1 0 1 0 1.102-1.668A9 9 0 1 1 18.714 6Z\'/><path d=\'M8.496 15.139v-1.4c.915-.066 1.577-.229 1.988-.49.41-.27.663-.668.756-1.19h1.778v9.94h-2.016v-6.86H8.496Zm9.985 7.098c-.728 0-1.381-.126-1.96-.378a3.14 3.14 0 0 1-1.358-1.12c-.336-.495-.513-1.083-.532-1.764h2.03c.01.298.084.564.224.798.15.233.35.415.602.546.262.121.56.182.896.182.355 0 .658-.07.91-.21a1.53 1.53 0 0 0 .602-.616c.14-.262.21-.565.21-.91 0-.336-.07-.635-.21-.896a1.44 1.44 0 0 0-.602-.602 1.725 1.725 0 0 0-.896-.224 1.89 1.89 0 0 0-1.008.266c-.29.168-.5.378-.63.63H14.8l.588-5.88h6.23v1.834h-4.619l-.269 2.624c.07-.115.16-.23.268-.342a2.37 2.37 0 0 1 .854-.532c.346-.14.719-.21 1.12-.21a3.3 3.3 0 0 1 1.638.406c.485.261.863.634 1.134 1.12.27.485.406 1.05.406 1.694 0 .672-.15 1.283-.448 1.834-.299.541-.728.97-1.288 1.288-.55.308-1.195.462-1.932.462Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconSkipForward15 is deprecated and will be archived soon. Use IconSkipForward15 instead.
 */
function Experimental__IconSkipForward15(props) {
  return /*#__PURE__*/_react["default"].createElement(IconSkipForward15, props);
}